import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { getIsSignedIn } from './selectors';
import { logout as logoutActions } from './actions';
import { loginRoute } from '../../routes';
import Splash from '../../components/Splash';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';

export class Logout extends React.Component {
  componentDidMount() {
    const { logout } = this.props;
    logout();
  }

  render() {
    const { isSignedIn, history } = this.props;

    if (isSignedIn) {
      return 'Signing out';
    }

    const content = (
      <Typography>
        {isSignedIn ? (
          <FormattedMessage id="logout.contentIsSigningOut" />
        ) : (
          <FormattedMessage id="logout.contentIsSignedOut" />
        )}
      </Typography>
    );

    return (
      <Splash
        actions={
          <Button
            onClick={() => history.push(loginRoute())}
            type="submit"
            size="small"
            color="secondary"
          >
            <FormattedMessage id="logout.buttonSignIn" />
          </Button>
        }
        content={content}
      />
    );
  }
}

export default withRouter(
  connect(
    state => ({
      isSignedIn: getIsSignedIn(state)
    }),
    { logout: logoutActions }
  )(ImmutablePropsToJS(Logout))
);
